import { Table, Pagination } from "react-bootstrap";
import { getOrderDetailsByUser } from '../../../../components/Service/OrderCSHP';
// import './Order.css';
import { FaCog } from 'react-icons/fa';
import React, { useState, useEffect } from 'react';
import useLanguage from '../../../../Hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import LoadingSpinner from "../../../../css/Loading";
const Order2 = () => {
    const [order, setOrder] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredOrder, setFilteredOrder] = useState([]);
    const [statusFilter, setStatusFilter] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(true);

    const { t } = useTranslation();
    useLanguage();

    useEffect(() => {
        const fetchData = async () => {
            const data = await getOrderDetailsByUser();
            const sortedData = data.order_details?.sort((a, b) => b.id - a.id) || [];
            const filterpanel = sortedData.filter(row => row.type_order !== "panel");
            setOrder(filterpanel);
            setFilteredOrder(filterpanel);
            setLoading(false);

        };
        fetchData();
    }, []);

    useEffect(() => {
        const filteredData = order.filter((item) => {
            const imageVersion = `${item.images} ${item.images_version}`.toLowerCase();
            const statusMapping = {
                0: "Pending",
                1: "Active",
                2: "Suspended",
                3: "Cancelled",
                4: "Fraud",
                5: "Complete",
                6: "Processing",
                7: "On Hold",
                8: "Pending Cancellation",
                9: "Reinstall",
                10: "Terminated",
            };
            const itemStatus = statusMapping[item.status] || "Pending";

            return (
                (item?.package[0]?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    item?.domain_hosting_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    imageVersion.includes(searchTerm.toLowerCase()) ||
                    item?.ip?.toLowerCase().includes(searchTerm.toLowerCase())) &&
                (statusFilter === "" || itemStatus === statusFilter)
            );
        });
        setFilteredOrder(filteredData);
        setCurrentPage(1);
    }, [searchTerm, statusFilter, order]);

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = filteredOrder.slice(indexOfFirstRow, indexOfLastRow);

    const totalPages = Math.ceil(filteredOrder.length / rowsPerPage);

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

    const handleRowsPerPageChange = (e) => {
        setRowsPerPage(parseInt(e.target.value, 10));
        setCurrentPage(1);
    };

    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });

        const sortedData = [...currentRows].sort((a, b) => {
            if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
            if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
            return 0;
        });

        setCurrentPage(sortedData);
    };
    if (loading) {
        return (
            <LoadingSpinner></LoadingSpinner>
        );
    }
    return (
        <>
            <style>
                {`
                    a {
                        text-decoration: none;
                    }
                `}
            </style>
            <div
                className="section-services"
            // style={{
            //     display: 'flex',
            //     flexDirection: 'column',
            //     height: '80vh',
            // }}
            >
                <div style={{ marginBottom: "20px" }} className="row">
                    <div className="row">

                        <h3 className="text-center mb-4" style={{ color: "#007bff" }}>{t("CSHP Management")}</h3>


                        <div className="col-12 col-md-3 col-lg-3 ">
                            <div className="form-group">
                                <label htmlFor="status" style={{ fontSize: 14, fontWeight: 700 }}>
                                    {t("Search")}
                                </label>
                                <div className="mb-3">
                                    <input
                                        type="text"
                                        placeholder={t("Search for products/services")}
                                        className="form-control"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-3 col-lg-3 ">
                            <div className="form-group">
                                <label htmlFor="status" style={{ fontSize: 14, fontWeight: 700 }}>
                                    {t("Status")}
                                </label>
                                <select
                                    name="status"
                                    className="form-control"
                                    style={{ fontSize: 14 }}
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                >
                                    <option value="">-- {t("All")} --</option>
                                    <option value="Pending">{t("Pending")}</option>
                                    <option value="Active">{t("Active")}</option>
                                    <option value="Suspended">{t("Suspended")}</option>
                                    <option value="Cancelled">{t("Cancelled")}</option>
                                    <option value="Fraud">{t("Fraud")}</option>
                                    <option value="Complete">{t("Complete")}</option>
                                    <option value="Processing">{("Processing")}</option>
                                    <option value="On Hold">{t("On Hold")}</option>
                                    <option value="Pending Cancellation">{t("Pending Cancellation")}</option>
                                    <option value="Reinstall">{t("Reinstall")}</option>
                                    <option value="Terminated">{t("Terminated")}</option>

                                </select>
                            </div>
                        </div>
                        <div className="col-12 col-md-2  col-lg-3">
                            <div className="form-group">
                                <label htmlFor="rowsPerPage" style={{ fontSize: 14, fontWeight: 700 }}>
                                    {t("Number of rows displayed")}
                                </label>
                                <select
                                    className="form-control"
                                    style={{ fontSize: 14 }}
                                    value={rowsPerPage}
                                    onChange={handleRowsPerPageChange}
                                >
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-12 col-md-4 col-lg-3">
                            <label style={{ fontSize: "15px" }}>
                                * {order.length} {t("Records Found")}, {t("Showing")} {indexOfFirstRow + 1} {t("to")} {Math.min(indexOfLastRow, order.length)}
                            </label>
                        </div>
                    </div>
                </div>

                <div
                    className="table-responsive table-borders table-radius"
                // style={{
                //     flex: 1,
                //     overflowY: 'auto',
                //     border: '1px solid #ddd',
                // }}
                >


                    <table className="table services-table position-relative stackable">
                        <thead>
                            <tr>
                                <th className="w-25">
                                    {t("Service")}

                                </th>
                                <th>
                                    {t("Hostname")}

                                </th>
                                <th>
                                    OS

                                </th>
                                <th>
                                    {t("IP address")}

                                </th>
                                <th>
                                    {t("Status")}

                                </th>

                                <th className="text-center">
                                    <FaCog />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentRows.map((muc, index) => (
                                <tr key={index}>
                                    <td>
                                        <a href={`/cshp/server/detail/${muc.id}`}>{muc?.package.name}</a>
                                    </td>
                                    <td>
                                        <a href={`/cshp/server/detail/${muc.id}`}>{muc?.domain_hosting_name || '-'}</a>
                                    </td>
                                    <td>{muc.images} {muc.images_version}</td>
                                    <td>{muc?.ip || '-'}</td>
                                    <td>
                                        <span className={`badge`} style={{
                                            backgroundColor: muc.status === 0 ? "#808080" :
                                                muc.status === 1 ? "#28A745" :               // Active - Green
                                                    muc.status === 2 ? "#FFC107" :           // Suspended - Yellow
                                                        muc.status === 3 ? "#DC3545" :       // Cancelled - Red
                                                            muc.status === 4 ? "#343A40" :   // Fraud - Dark
                                                                muc.status === 5 ? "#17A2B8" : // Complete - Cyan
                                                                    muc.status === 6 ? "#FD7E14" : // Processing - Orange
                                                                        muc.status === 7 ? "#007BFF" : // On Hold - Blue
                                                                            muc.status === 8 ? "#6F42C1" : // Pending Cancellation - Purple
                                                                                muc.status === 9 ? "#bcdbf7" : // Reinstall - Light Blue
                                                                                    muc.status === 10 ? "#A71D2A" : // Terminate - Dark Red
                                                                                        "orange" // Default
                                        }}>
                                            {
                                                muc.status === 0 ? t("Pending") :
                                                    muc.status === 1 ? t("Active") :
                                                        muc.status === 2 ? t("Suspended") :
                                                            muc.status === 3 ? t("Cancelled") :
                                                                muc.status === 4 ? t("Fraud") :
                                                                    muc.status === 5 ? t("Complete") :
                                                                        muc.status === 6 ? t("Processing") :
                                                                            muc.status === 7 ? t("On Hold") :
                                                                                muc.status === 8 ? t("Pending Cancellation") :
                                                                                    muc.status === 9 ? t("Reinstall") :
                                                                                        muc.status === 10 ? t("Terminate") : t("Pending")
                                            }
                                        </span>
                                    </td>

                                    {/* <td>{muc.end_date ? new Date(muc.end_date).toLocaleDateString('vi-VN') : '-'}</td> */}
                                    <td className="text-center">
                                        <FaCog />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                </div>

                <div
                    className="d-flex justify-content-center mt-1"
                // style={{
                //     position: 'sticky',
                //     bottom: '10px',
                //     backgroundColor: 'white',
                //     zIndex: 1000,
                //     display: 'flex',
                //     justifyContent: 'center',
                //     padding: '10px 0',
                //     boxShadow: '0 -2px 5px rgba(0, 0, 0, 0.1)',
                // }}
                >
                    <Pagination>
                        <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>{t("Previous")}</Pagination.Prev>
                        {[...Array(totalPages)].map((_, i) => (
                            <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => handlePageChange(i + 1)}>
                                {i + 1}
                            </Pagination.Item>
                        ))}
                        <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>{t("Next")}</Pagination.Next>
                    </Pagination>
                </div>
            </div>

        </>
    );
};

export default Order2;
